module.exports = __webpack_public_path__ + "img/icon-direct-message-gray.55cbabfb.svg";